<template>
    <div class="footer-bottom text-text-gray-color pb-10 text-center mx-w-1200 w-984 mt-6">
      <p>
        <a href="https://github.com/zermoser" target="_blank">
          <span class="title-link-footer fab fa-github"></span>
        </a>
        &nbsp;&nbsp;&nbsp;
        <a href="https://www.linkedin.com/in/kittipoj-naewthavorn-274809312" target="_blank">
          <span class="title-link-footer fab fa-linkedin"></span>
        </a>
        &nbsp;&nbsp;&nbsp;
        <a href="mailto:kittipoj.na@gmail.com">
            <span class="title-link-footer fas fa-envelope"></span>
        </a>
        &nbsp;&nbsp;&nbsp;
      </p>
      <div class="text-xl py-3">
        เว็บไซต์นี้จัดทำเพื่อการศึกษา มิได้มีเจตนาละเมิดลิขสิทธิ์ และไม่มีการซื้อขายจริงในเว็บไซต์นี้
      </div>
      <div class="text-xl pb-5">
        This website is for educational purpose. There is no intention of copyright infringement and no actual trade activities.
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "FooterBottom",
  };
  </script>
  
  <style scoped>

.title-link-footer {
	color: #af0408;
	font-size: 28px;
}
  </style>
  